import React, { useEffect } from "react";
import "../PasskeyPage/passkey.css";
import "./futuresRiskWarningModal.css";

export const FUTURES_RISK_WARNING_STORAGE_KEY = "agce_futures_trade_risk_warning_acknowledged";

/**
 * First-visit futures risk disclosure — dismissible only via acknowledge button.
 */
export default function FuturesRiskWarningModal({ open, onAcknowledge }) {
  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="passkey-modal-overlay agce-futures-risk-modal__overlay" role="presentation">
      <div
        className="passkey-modal agce-futures-risk-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="futures-risk-modal-title"
      >
        <div className="passkey-modal__art" aria-hidden="true">
          <img className="dark_img" src="/images/security/security_risk_vector.svg" alt="" />
          <img className="light_img" src="/images/security/security_risk_vector_light.svg" alt="" />
        </div>

        <h2 id="futures-risk-modal-title" className="passkey-modal__title">
          Futures Risk Warning
        </h2>
        <p className="passkey-modal__subtitle agce-futures-risk-modal__text">
          Futures and perpetual contract trading involves significant risk. Leverage can magnify both
          profits and losses, and you may lose your entire margin if the market moves against you.
          Positions may be liquidated, funding fees apply, and prices can change rapidly. Please trade
          responsibly and only use funds you can afford to lose.
        </p>

        <button type="button" className="agce-futures-risk-modal__btn" onClick={onAcknowledge}>
          I Understand the Risks
        </button>
      </div>
    </div>
  );
}
